import languages from "@/data/languages.json";

const BASE_LANGUAGES = languages as Record<string, string>;

export const PODCAST_SUPPORTED_LANGUAGES: Record<string, string> = {
  ...BASE_LANGUAGES,
  Arabic: "ar-XA",
  Mandarin: "cmn-CN",
  Portuguese: "pt-BR",
  Spanish: "es-ES",
  "Cantonese (Hong Kong)": "yue-HK",
};

const AZURE_LANGUAGE_CODE_MAPPING: Record<string, string> = {
  "ar-XA": "ar-SA",
  "cmn-CN": "zh-CN",
  "yue-HK": "zh-HK",
};

export function getPodcastLanguageCode(languageName: string | null | undefined) {
  if (!languageName) return "en-US";
  return PODCAST_SUPPORTED_LANGUAGES[languageName] || "en-US";
}

export function getAzurePodcastLanguageCode(languageCode: string | null | undefined) {
  if (!languageCode) return "en-US";
  return AZURE_LANGUAGE_CODE_MAPPING[languageCode] || languageCode;
}

export function isChineseBasedPodcastLanguage(languageName: string) {
  const code = getPodcastLanguageCode(languageName);
  return (
    code === "cmn-CN" ||
    code === "zh-CN" ||
    code === "yue-HK" ||
    languageName.includes("Cantonese") ||
    languageName.includes("Mandarin") ||
    languageName.includes("Chinese")
  );
}
